(() => {
 if (customElements.get('inno-hero-slider')) return;
 class InnoHeroSlider extends HTMLElement {
  connectedCallback() {
   this.track = this.querySelector('.inno-slides');
   this.slides = [...this.querySelectorAll('.inno-slide')];
   this.dots = [...this.querySelectorAll('[data-index]')];

   this.index = 0;
   this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
   this.enabled = this.dataset.autoplay === 'true' && !this.reduced;
   this.hovered = false; this.focused = false;
   this.controller = new AbortController();
   const on = (target, event, fn) => target.addEventListener(event, fn, {signal:this.controller.signal});
   this.querySelector('[data-prev]') && on(this.querySelector('[data-prev]'),'click',()=>this.go(this.index-1));
   this.querySelector('[data-next]') && on(this.querySelector('[data-next]'),'click',()=>this.go(this.index+1));
   this.dots.forEach(dot=>on(dot,'click',()=>this.go(Number(dot.dataset.index))));
   on(this,'mouseenter',()=>{this.hovered=true;this.start();});
   on(this,'mouseleave',()=>{this.hovered=false;this.start();});
   on(this,'focusin',()=>{this.focused=true;this.start();});
   on(this,'focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.start();}));
   on(document,'visibilitychange',()=>this.start());
   on(this.track,'scroll',()=>{
    const width=this.track.clientWidth;
    if(width) {this.index=Math.min(this.slides.length-1,Math.round(this.track.scrollLeft/width));this.update();}
   });
   on(document,'shopify:block:select',event=>{
    const i=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail.blockId);
    if(i>=0) {this.enabled=false;this.go(i);}
   });
   this.observer=new ResizeObserver(()=>this.go(this.index,false));
   this.observer.observe(this.track);this.update();this.start();
  }
  go(index,smooth=true) {
   if(!this.slides.length)return;
   this.index=(index+this.slides.length)%this.slides.length;
   this.track.scrollTo({left:this.index*this.track.clientWidth,behavior:smooth&&!this.reduced?'smooth':'auto'});
   this.update();this.start();
  }
  update() {
   this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));
   this.slides.forEach((slide,i)=>{slide.inert=i!==this.index;});
  }
  start(){clearInterval(this.timer);if(this.enabled&&!this.hovered&&!this.focused&&!document.hidden&&this.slides.length>1)this.timer=setInterval(()=>this.go(this.index+1),Number(this.dataset.interval)||6000);}
  disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();this.observer?.disconnect();}
 }
 customElements.define('inno-hero-slider',InnoHeroSlider);
})();
